import React from "react";

export interface NavProp {
  link: string;
  id: number;
  label: string;
}

const Nav: React.FC<{
  navArr: Array<NavProp>;
  linkColor: string;
  position?: string;
}> = ({ navArr, linkColor, position }) => {
  return (
    <ul className={`d-md-flex nav-class justify-content-${position}`}>
      {navArr.map((nav) => {
        return (
          <li className="mr-3" key={nav.id}>
            <a className={linkColor} href={nav.link}>
              {nav.label}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default Nav;
